import React, { useState, useRef, useEffect } from 'react';
import infoIcon from '../../assets/admin/icons/info.svg';
import './InfoIcon.css';

const InfoIcon = ({ info }) => {
   const [showTooltip, setShowTooltip] = useState(false);
   const tooltipRef = useRef(null);

   useEffect(() => {
      if (showTooltip && tooltipRef.current) {
         const tooltip = tooltipRef.current;
         const rect = tooltip.getBoundingClientRect();

         // Als tooltip uit het scherm valt aan de rechterkant
         if (rect.right > window.innerWidth) {
            tooltip.style.left = 'auto';
            tooltip.style.right = '0';
            tooltip.style.transform = 'none';
         }
         // Als tooltip uit het scherm valt aan de linkerkant
         if (rect.left < 0) {
            tooltip.style.left = '0';
            tooltip.style.transform = 'none';
         }
      }
   }, [showTooltip]);

   return (
      <div className="info-icon-container">
         <img 
            src={infoIcon} 
            alt="Info" 
            className="info-icon"
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
         />
         {showTooltip && (
            <div className="info-tooltip" ref={tooltipRef}>
               {info}
            </div>
         )}
      </div>
   );
};

export default InfoIcon;
